import React, { useMemo } from 'react';
import { GivelifyLabel } from '@givelify/givelify-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../routes';
import { minSearchCardHeight, searchCardBorderRadius } from './SearchLoading';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import { signSetAction } from '../../../store/signup/actions';
import { defaultOrganization } from '../../../store/signup/types';
import { pushEvent } from '../../../utils/clevertapUtils';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { CLICK_ORG_SEARCH_MANUAL_SIGN_UP_BTN } from '../../../utils/clevertapEvents';
import { AppState } from '../../../store';
import Link from '@material-ui/core/Link/Link';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cardStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            border: '1px dashed #E3E3E3',
            height: '100%',
            cursor: 'pointer',
            minHeight: minSearchCardHeight,
            borderRadius: searchCardBorderRadius,
            '& .link': {
                marginTop: theme.spacing(2),
            },
        },
    }),
);

const CantFindOrganizationCard: React.FC = () => {
    const dispatch = useAppDispatch();
    const push = useNavigate();
    const { t } = useTranslation();
    const { cardStyles } = useStyles();
    const organizationName = useSelector(
        (state: AppState) => state.Signup.organizationName,
    );
    const { organizationNotFound, signupManuallyText } = useMemo(
        () => ({
            organizationNotFound: t(
                'signup.organizationSearch.organizationNotFound',
            ),
            signupManuallyText: t(
                'signup.organizationSearch.signupManuallyText',
            ),
        }),
        [t],
    );
    const onClick = () => {
        dispatch(signSetAction(defaultOrganization));
        pushEvent(CLICK_ORG_SEARCH_MANUAL_SIGN_UP_BTN, { organizationName });
        push(PATH.SIGNUP.STEPS.ADD_ORGANIZATION);
    };
    return (
        <div className={cardStyles} onClick={onClick}>
            <GivelifyLabel variant="body1" bold text={organizationNotFound} />
            <Link className="link">{signupManuallyText}</Link>
        </div>
    );
};

export default CantFindOrganizationCard;
